<template>
  <div class="field-option-date-picker-wrapper">
    <van-field
      :value="value"
      readonly
      label="日期"
      size="large"
      placeholder="请选择日期"
      right-icon="arrow"
      @click="toggleDatePicker"
    />
    <span class="keep border-bottom" />
    <van-popup v-model="isDatePickerShown" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        title="选择日期"
        @cancel="toggleDatePicker"
        @confirm="handleConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Dialog } from 'vant';

export default {
  props: {
    date: [Array],
  },
  data() {
    return {
      value: '',
      isDatePickerShown: false,
    };
  },
  computed: {
    columns() {
      return this.date.map(item => {
        return `${item.date} ${item.count === -1 ? '' : `(${item.count}人)`} ${item.tab}`;
      });
    },
  },
  methods: {
    toggleDatePicker() {
      this.isDatePickerShown = !this.isDatePickerShown;
    },
    handleConfirm(date, index) {
      if (this.date[index].valid) {
        this.value = date;
        this.$emit('change', this.date[index]);
        this.toggleDatePicker();
      } else {
        Dialog.alert({ title: '提示', message: this.date[index].notice });
      }
    },
  },
};
</script>
<style lang="less" scoped></style>
